import { createAction, props } from '@ngrx/store'
import { Coupon, CouponAnalytics } from './coupon.state'

/* ===========================
        LOAD COUPONS
=========================== */

export const loadCoupons = createAction(
  '[Coupon] Load Coupons',
  props<{ params?: string | null; page?: number; limit?: number; context?: 'list' | 'modal' }>()
)

export const loadCouponsSuccess = createAction(
  '[Coupon] Load Coupons Success',
  props<{
    coupons: Coupon[]
    totalCount: number
    activeCount: number
    inactiveCount: number
    expiredCount: number
  }>()
)

export const loadCouponsFailure = createAction(
  '[Coupon] Load Coupons Failure',
  props<{ error: string }>()
)

/* ===========================
        ANALYTICS
=========================== */

export const loadCouponAnalytics = createAction('[Coupon] Load Coupon Analytics')

export const loadCouponAnalyticsSuccess = createAction(
  '[Coupon] Load Coupon Analytics Success',
  props<{ analytics: CouponAnalytics }>()
)

export const loadCouponAnalyticsFailure = createAction(
  '[Coupon] Load Coupon Analytics Failure',
  props<{ error: any }>()
)

/* ===========================
        GET BY ID
=========================== */

export const loadCouponById = createAction('[Coupon] Load Coupon By Id', props<{ id: string }>())

export const loadCouponByIdSuccess = createAction(
  '[Coupon] Load Coupon By Id Success',
  props<{ coupon: Coupon }>()
)

export const loadCouponByIdFailure = createAction(
  '[Coupon] Load Coupon By Id Failure',
  props<{ error: any }>()
)

/* ===========================
        CREATE
=========================== */

export const createCoupon = createAction(
  '[Coupon] Create Coupon',
  props<{
    coupon: Partial<Coupon>
  }>()
)

export const createCouponSuccess = createAction(
  '[Coupon] Create Coupon Success',
  props<{ coupon: Coupon }>()
)

export const createCouponFailure = createAction(
  '[Coupon] Create Coupon Failure',
  props<{ error: any }>()
)

/* ===========================
        UPDATE
=========================== */

// export const updateCoupon = createAction(
//   '[Coupon] Update Coupon',
//   props<{
//     id: string
//     coupon: Partial<Coupon>
//   }>()
// )

export const updateCoupon = createAction(
  '[Coupon] Update Coupon',
  props<{
    id: string
    coupon: any
    params?: string
    page?: number
    limit?: number
  }>()
)

export const updateCouponSuccess = createAction(
  '[Coupon] Update Coupon Success',
  props<{ coupon: Coupon }>()
)

export const updateCouponFailure = createAction(
  '[Coupon] Update Coupon Failure',
  props<{ error: any }>()
)

/* ===========================
        DELETE
=========================== */

export const deleteCoupon = createAction('[Coupon] Delete Coupon', props<{ id: string }>())

export const deleteCouponSuccess = createAction(
  '[Coupon] Delete Coupon Success',
  props<{ id: string }>()
)

export const deleteCouponFailure = createAction(
  '[Coupon] Delete Coupon Failure',
  props<{ error: any }>()
)

/* ===========================
        RESET
=========================== */

export const resetCouponState = createAction('[Coupon] Reset State')
